import {ModuleComponent} from "../../js/module-component";

export class ModHeader extends ModuleComponent{

    ready(){

        super.ready();

        this.findMember("opener").click(
            (ev)=>{
                ev.preventDefault();
                ev.stopPropagation();
                this.$root.find(this.scope+"__menu").toggleClass("menu__open");
                $(this).toggleClass("is-opened");
                $("body").toggleClass("u-no-scroll");
            }
        );

        /*Menu mobile*/
        this.findMember("icon").click(
            (ev)=>{
                ev.preventDefault();
                ev.stopPropagation();
                this.$root.find(this.scope+"__menu").toggleClass("responsive");
                this.$root.find(this.scope+"__nav-icon1").toggleClass("open");
            }
        );

        this.$root.find("[href^=\"#popup\"]").click(
            (ev)=>{
                ev.preventDefault();
                var href = $(ev.currentTarget).attr("href");
                var $popup = $(href);
                $popup.fadeIn();
                $popup.find(".js-popup__close").click(
                    (ev)=>{
                        ev.preventDefault();
                        $popup.fadeOut();
                    }
                );
            }
        );

        var $body = $("body");
        inView(this.scope)
        .on("enter",function(){
            $body.removeClass("has-header-out");
        })
        .on("exit",function(){
            $body.addClass("has-header-out");
        });

        //if header is not in viewport we add class to body
        if(!inView.is(this.$root.get(0))){
            $body.addClass("has-header-out");
        }
    }
}